export const formatAccountAge = (hours) => {
    if (hours === null || typeof hours === 'undefined') return '—';
    const h = Number(hours);
    if (Number.isNaN(h)) return '—';
    const days = Math.floor(h / 24);
    const remHours = Math.floor(h % 24);
    if (days > 0) return `${days}d ${remHours}h`;
    return `${remHours}h`;
};

export const formatDateTime = (value) => (value ? new Date(value).toLocaleString() : '—');

export const userName = (user) => {
    if (!user) return '—';
    const name = `${user.first_name || ''} ${user.last_name || ''}`.trim();
    return name || user.email || '—';
};

export const CLASSIFICATION_OPTIONS = [
    { value: '', label: 'All Classifications' },
    { value: 'WATCH', label: 'Watch' },
    { value: 'HOLD', label: 'Hold' },
    { value: 'CRITICAL_HOLD', label: 'Critical Hold' },
];

export const STATUS_OPTIONS = [
    { value: '', label: 'All Statuses' },
    { value: 'watch', label: 'Watch' },
    { value: 'under_review', label: 'Under Review' },
    { value: 'pending_hold', label: 'Pending Hold' },
    { value: 'resolved', label: 'Resolved' },
];

export const classificationBadgeClass = (classification) => {
    switch (classification) {
        case 'CRITICAL_HOLD':
            return 'badge badge-danger';
        case 'HOLD':
            return 'badge badge-warning';
        case 'WATCH':
            return 'badge badge-info';
        default:
            return 'badge badge-secondary';
    }
};
